import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AcPaginatorIntl extends MatPaginatorIntl {
  public constructor(private translateService: TranslateService) {
    super();
    this.translateService.onLangChange.subscribe(() => {
      this.getPaginatorIntl();
    });
  }

  getPaginatorIntl() {
    this.translateService
      .get([
        'UI.Common.Paginator.ItemsPerPage',
        'UI.Common.Paginator.NextPage',
        'UI.Common.Paginator.PreviousPage',
        'UI.Common.Paginator.FirstPage',
        'UI.Common.Paginator.LastPage'
      ])
      .subscribe(translation => {
        this.itemsPerPageLabel = translation['UI.Common.Paginator.ItemsPerPage'];
        this.nextPageLabel = translation['UI.Common.Paginator.NextPage'];
        this.previousPageLabel = translation['UI.Common.Paginator.PreviousPage'];
        this.firstPageLabel = translation['UI.Common.Paginator.FirstPage'];
        this.lastPageLabel = translation['UI.Common.Paginator.LastPage'];
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.translateService.instant('UI.Common.Paginator.RangePageLabel1', { length });
    }
    const label = this.translateService.instant('UI.Common.Paginator.RangePageLabel2');
    const amountPages = Math.ceil(length / pageSize);
    return `${label} ${page + 1} / ${amountPages}`;
  };
}
